"use client";

import { useState } from "react";
import { ICL_UG_Programmes } from "@/data/ICL_UG_Programmes"
import { Search } from "lucide-react";
import PartnerPrograms from "@/components/industry-co-led/PartnerPrograms";
import FilterButtons from "@/components/industry-co-led/FilterButtons";
const ProgrammesPage = () => {

    const [selectedCategory, setSelectedCategory] = useState("All");

    const [search, setSearch] = useState("");

    const filteredProgrammes =
        ICL_UG_Programmes.programmes.filter((prog) => {

            const matchesCategory =
                selectedCategory === "All" ||
                prog.category === selectedCategory;

            const matchesSearch =
                prog.title
                    .toLowerCase()
                    .includes(search.toLowerCase());

            return matchesCategory && matchesSearch;
        });

    return (

        <div className="w-full mx-auto my-5 md:my-8">
            <div className="relative mb-6 w-full md:max-w-[80%]">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 " />

                <input
                    type="text"
                    placeholder="Search programmes..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="w-full border-[1.13px] border-gray-300 pl-10 pr-4 py-2 bg-[rgba(249,250,251,1)] rounded-xs focus:outline-none"
                />
            </div>
            <FilterButtons
                categories={ICL_UG_Programmes.categories}
                selected={selectedCategory}
                onSelect={setSelectedCategory}
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">

                {filteredProgrammes.map((prog) => (

                    <PartnerPrograms
                        key={prog.id}
                        programme={prog}
                    />

                ))}

            </div>

        </div>
    );
}

export default ProgrammesPage;